{
  "status": {
    "pending_verification": "Waiting for 本人確認",
    "active": "Active",
    "suspended": "Paused",
    "closed": "Closed"
  },
  "columns": {
    "reference": "No.",
    "name": "Name",
    "kyc": "本人確認",
    "items": "Cards with us",
    "awaiting": "To pay out",
    "payout": "Paid by",
    "no_account": "no bank account yet",
    "status": "State"
  },
  "filters": {
    "q": "Search",
    "q_placeholder": "Name, カナ, CON- number or e-mail"
  },
  "views": {
    "not_verified": "本人確認 not done"
  },
  "list": {
    "intro": "People who leave cards with the shop to sell. 本人確認 (古物営業法) must be done before any card is taken in.",
    "create": "New consignor"
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "payout": {
    "bank_transfer": "Bank transfer",
    "cash": "Cash at the shop",
    "store_credit": "Store credit",
    "stripe_connect": "Online payout"
  },
  "fee": {
    "shop_absorbs": "The shop pays the card fee",
    "consignor_pro_rata": "The consignor pays their share of the card fee",
    "split_50_50": "Half each"
  },
  "fee_help": {
    "shop_absorbs": "The consignor gets the price minus the commission, whatever way the buyer paid.",
    "consignor_pro_rata": "When a buyer pays by card, the card company's fee for that card is taken from the payout.",
    "split_50_50": "The card company's fee is shared: half from the shop, half from the payout."
  },
  "schedule": {
    "monthly": "Once a month",
    "on_request": "When they ask"
  },
  "form": {
    "profile": "Details",
    "displayName": "Name shown",
    "displayName_hint": "How staff and the portal call them.",
    "legalName": "Full legal name",
    "legalName_hint": "As on the ID (for 古物台帳).",
    "nameKana": "Name in カナ",
    "email": "E-mail",
    "phone": "Phone",
    "locale": "Language",
    "address": "Address",
    "postalCode": "Postal code",
    "region": "Prefecture",
    "city": "City",
    "address1": "Street and number",
    "address2": "Building, room",
    "payoutMethod": "How are they paid?",
    "commission": "Shop commission",
    "commission_hint": "Empty = the shop's usual rules.",
    "payoutSchedule": "Payout rhythm",
    "minPayout": "Smallest payout",
    "minPayout_hint": "Smaller amounts wait for the next time.",
    "feePolicy": "Card fees (when a buyer pays by card)",
    "invoiceRegistered": "Registered for インボイス (has a 登録番号)",
    "taxId": "登録番号",
    "taxId_hint": "T and 13 digits, e.g. T1234567890123.",
    "baikaisha_note": "Registered consignors: the shop may issue the invoice for them (媒介者交付特例). ⚠️ Confirm how you use it with your tax accountant (税理士).",
    "notes": "Notes (staff only)",
    "save": "Save the details",
    "saved": "Details saved",
    "stale": "Someone changed this consignor a moment ago. Open it again."
  },
  "problems": {
    "display_name": "Write a name.",
    "email": "This e-mail does not look right.",
    "commission": "A percentage between 0 and 100.",
    "tax_id": "T and 13 digits.",
    "min_payout": "Whole yen.",
    "fix": "Fix the boxes marked in red first."
  },
  "bank": {
    "title": "Bank account for payouts",
    "none": "No bank account yet.",
    "add": "Add the bank account",
    "change": "Enter a new account",
    "description": "Type the whole account. It is stored locked; staff only see the last digits afterwards.",
    "later": "Needed for payment by bank transfer. No account yet? Choose cash or store credit for now.",
    "bankName": "Bank",
    "branchCode": "Branch number",
    "branch_hint": "3 digits (ゆうちょ: see the bank book).",
    "accountNumber": "Account number",
    "holderKana": "Account holder (カナ)",
    "accountType": "Account type",
    "save": "Save the account",
    "saved": "Bank account saved",
    "incomplete": "Fill in every box of the account (numbers only), or leave them all empty.",
    "required": "Payment by bank transfer needs the account — fill it in, or choose cash / store credit."
  },
  "kpi": {
    "active": "Cards with us",
    "sold": "Sold",
    "awaiting": "To pay out",
    "paid": "Paid so far"
  },
  "stages": {
    "received": "Received",
    "under_review": "Being checked",
    "ready_to_list": "Ready",
    "listed": "On sale",
    "reserved": "In an order",
    "paused": "Paused",
    "sold": "Sold",
    "return_in_progress": "Going back",
    "returned": "Given back",
    "closed": "Done"
  },
  "link": {
    "title": "Portal sign-in",
    "open": "Open their customer account",
    "email": "E-mail for the portal",
    "hint": "The consignor sees their cards and payouts with this e-mail.",
    "send_invite": "Send the invitation e-mail",
    "submit": "Link the account",
    "created": "Account made and linked",
    "linked": "Account linked",
    "invited": "Invitation sent to {{email}}."
  },
  "status_change": {
    "needs_kyc": "Do 本人確認 first.",
    "to": {
      "active": "Activate",
      "suspended": "Pause",
      "closed": "Close",
      "pending_verification": "Back to waiting"
    },
    "title": {
      "active": "Activate this consignor?",
      "suspended": "Pause this consignor?",
      "closed": "Close this consignor?",
      "pending_verification": "Put back to waiting?"
    },
    "consequence": {
      "active": "Cards can be taken in and sold.",
      "suspended": "No new cards are taken in; cards on sale stay.",
      "closed": "No new cards. Cards with the shop must be sold or given back first.",
      "pending_verification": "No cards are taken in until 本人確認 is done."
    },
    "done": {
      "active": "Consignor activated",
      "suspended": "Consignor paused",
      "closed": "Consignor closed",
      "pending_verification": "Back to waiting"
    }
  },
  "agreement": {
    "title": "Consignment agreement",
    "accepted": "Signed (version {{version}})",
    "missing": "Not signed yet — cards cannot be taken in.",
    "record": "The consignor signed version {{version}}",
    "record_title": "Record the signed agreement?",
    "record_consequence": "Only when the consignor signed the paper agreement at the shop.",
    "record_confirm": "Record it",
    "recorded": "Agreement recorded",
    "open_pdf": "Open the signed agreement"
  },
  "view_as": {
    "button": "View as the consignor",
    "opened": "The consignor's portal opened in a new tab",
    "hint": "Read only, for 15 minutes. Recorded."
  },
  "detail": {
    "back": "All consignors",
    "load_failed": "The consignor could not be opened",
    "status_reason": "Reason:",
    "privacy": "Bank and ID numbers are stored locked. Every look is recorded.",
    "take_in": "Take in cards",
    "their_cards": "Their cards",
    "their_sales": "Their sales",
    "pay_now": "Pay now"
  },
  "new": {
    "title": "New consignor",
    "intro": "A few details, then 本人確認 right away.",
    "save": "Save and do 本人確認",
    "created": "{{reference}} made",
    "created_hint": "Now the 本人確認."
  },
  "masked": {
    "show": "Show",
    "hide": "Hide ({{seconds}} s)",
    "recorded": "This look is recorded. It hides itself after 30 seconds."
  },
  "address": {
    "postalCode": "Postal code",
    "region": "Prefecture",
    "city": "City",
    "address1": "Street and number",
    "address2": "Building, room",
    "country": "Country",
    "postal_hint": "7 digits fill in the rest.",
    "postal_found": "Address filled in — add the house number.",
    "postal_unknown": "This postal code was not found — type the address."
  },
  "kyc": {
    "title": "本人確認 (identity check)",
    "state": {
      "verified": "✅ Checked",
      "expired": "⚠️ Ended — check again",
      "pending": "Waiting to be checked",
      "rejected": "❌ Not accepted",
      "missing": "❌ Not done"
    },
    "start": "Do 本人確認",
    "again": "Check again",
    "none_body": "Not done yet. Cards can only be taken in after it.",
    "details_hidden": "The ID details are only for staff allowed to see them.",
    "form_title": "本人確認",
    "form_description": "Look at the ID, type what the law asks for, take a picture. Nothing else is asked.",
    "save_verified": "I checked the ID — save",
    "save_pending": "Save (check later)",
    "saved_verified": "本人確認 done",
    "saved_pending": "本人確認 saved — waiting to be checked",
    "valid_until": "Valid until {{day}}.",
    "valid_until_label": "Valid until",
    "checked": "Checked",
    "channel": "Where",
    "channels": {
      "face_to_face": "At the counter",
      "remote": "Not face to face (post / online)"
    },
    "method": "Which ID?",
    "methods": {
      "drivers_license": "Driving licence",
      "my_number_card": "My Number card",
      "passport": "Passport",
      "residence_card": "Residence card (在留カード)",
      "health_insurance_card": "Health insurance card",
      "other_official_id": "Other official ID",
      "remote_ekyc_photo_id": "Online: photo ID + face",
      "remote_ic_chip": "Online: IC chip of the ID",
      "remote_my_number_signature": "Online: My Number signature",
      "remote_seal_certificate": "Seal certificate by post",
      "remote_honnin_gentei_mail": "本人限定受取郵便",
      "remote_juminhyo_registered_mail": "住民票 + registered mail",
      "remote_juminhyo_same_name_transfer": "住民票 + transfer to same-name account",
      "remote_id_copy_registered_mail_transfer": "ID copy + registered mail + transfer",
      "remote_two_ids_delivery_record": "Two IDs + delivery record",
      "remote_returning_customer_credential": "Returning customer (checked before)",
      "remote_other_rule15_3": "Other (rule 15-3)"
    },
    "document_number_hint": "Stored locked; later only the last 4 are shown.",
    "fields": {
      "full_name": "Full name",
      "name_kana": "Name in カナ",
      "address": "Address",
      "occupation": "Occupation",
      "date_of_birth": "Date of birth",
      "picture": "picture of the ID",
      "document_number": "ID number",
      "document_expiry": "ID valid until"
    },
    "occupations": {
      "employee": "会社員",
      "self_employed": "自営業",
      "student": "学生",
      "homemaker": "主婦・主夫",
      "none": "無職"
    },
    "age": "Age: {{age}}",
    "age_at_check": "Age when checked",
    "dob_hint": "The age is worked out from it.",
    "minor_title": "Under 18 (age {{age}})",
    "minor_body": "Attach the parent's / guardian's written consent (青少年条例) — it cannot be saved without it.",
    "minor_blocked_body": "The shop does not take cards from people under 18.",
    "minor_short": "under 18",
    "guardian_consent": "Guardian's consent (photo)",
    "picture_front": "ID — front",
    "picture_back": "ID — back (if needed)",
    "picture_alt": "ID picture {{n}}",
    "show_picture": "Show picture {{n}}",
    "hide_picture": "Hide",
    "no_pictures": "No pictures.",
    "privacy": "The pictures are stored locked and kept only as long as the law says (3 years).",
    "blocker": {
      "minor_blocked": "Under 18: the shop does not accept this.",
      "blocked": "This check cannot be accepted (shop rule).",
      "minor_consent": "Under 18: attach the guardian's consent first.",
      "missing": "Still needed: {{fields}}.",
      "uploading": "Wait until the pictures are uploaded."
    },
    "verify": "Mark as checked",
    "verified": "本人確認 checked",
    "reject": "Not accepted",
    "rejected": "本人確認 not accepted",
    "reject_title": "Not accept this check?",
    "reject_consequence": "The consignor must show an ID again. Write why.",
    "reject_reason": "Why not accepted"
  }
}
